import { Users, BarChart3, Dumbbell, Utensils, Flame, CalendarCheck } from 'lucide-react';

export function AdminStatsGrid({ stats }) {
  if (!stats) return null;
  const items = [
    { icon: Users, label: 'Membres', value: stats.members, color: '#FF6B35' },
    { icon: BarChart3, label: 'Metriques', value: stats.metrics_entries, color: '#3b82f6' },
    { icon: Dumbbell, label: 'Exercices', value: stats.exercises_logged, color: '#ef4444' },
    { icon: Utensils, label: 'Repas', value: stats.meals_logged, color: '#10b981' },
    { icon: Flame, label: 'Challenges', value: stats.challenges, color: '#f59e0b' },
    { icon: CalendarCheck, label: 'Events', value: stats.events, color: '#8b5cf6' },
  ];
  return (
    <div className="grid grid-cols-3 gap-2" data-testid="admin-stats">
      {items.map(s => (
        <div key={s.label} className="bg-[#1B1B1B] border border-[#2A2A2E] rounded-sm p-3 text-center">
          <s.icon className="w-4 h-4 mx-auto mb-1" style={{ color: s.color }} />
          <p className="font-mono text-lg font-bold text-white">{s.value}</p>
          <p className="text-xs text-zinc-400">{s.label}</p>
        </div>
      ))}
    </div>
  );
}
